<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      width="30px"
      height="30px"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path
        d="M697.539048 279.161905h142.872381v589.531428c0 30.47619-23.161905 53.638095-53.638096 53.638096H215.28381c-30.47619 0-53.638095-23.161905-53.638096-53.638096v-714.361904c0-30.47619 23.161905-53.638095 53.638096-53.638096h446.659047v142.872381h35.84v35.596191z m-53.638096-17.798095V118.491429H215.28381c-19.748571 0-35.84 16.091429-35.84 35.84v714.361904c0 19.748571 16.091429 35.84 35.84 35.84h571.489523c19.748571 0 35.84-16.091429 35.84-35.84V296.96h-142.872381v-35.84h-35.84z m0 0"
        fill="#9FA0A6"
      />
      <path
        d="M670.72 296.96h-26.819048V100.449524h17.798096v17.798095h17.798095v17.798095h17.798095v17.798096h17.798095v17.798095h17.798096v17.798095h17.798095V207.238095h17.798095v17.798095h17.798095v17.798096h17.798096v17.798095h17.798095v17.798095h17.798095v17.798095h-196.510476v-26.819047c0.731429 15.11619 13.165714 27.550476 27.550476 27.550476z m0 0"
        fill="#9FA0A6"
      />
      <path
        d="M143.847619 189.927619h285.744762c19.748571 0 35.84 16.091429 35.84 35.84v285.744762c0 19.748571-16.091429 35.84-35.84 35.84H143.847619c-19.748571 0-35.84-16.091429-35.84-35.84V225.52381c0-19.504762 16.091429-35.59619 35.84-35.596191z m0 0"
        fill="#FF822E"
      />
      <path
        d="M223.817143 510.537143c-12.434286 0-22.674286-10.24-22.674286-22.674286v-213.333333c0-12.434286 10.24-22.674286 22.674286-22.674286h22.674286V487.619048c-0.24381 12.678095-10.24 22.918095-22.674286 22.918095z"
        fill="#FFFFFF"
      />
      <path
        d="M279.893333 412.038095H203.093333v-129.462857c0-18.041905 14.628571-32.426667 32.426667-32.426667h43.154286c42.666667 0 78.506667 32.670476 81.92 74.361905 1.706667 22.430476-5.851429 44.860952-21.211429 61.44-15.36 16.579048-37.059048 26.087619-59.489524 26.087619zM248.685714 366.445714h31.207619c9.752381 0 19.260952-4.144762 25.84381-11.459047 6.826667-7.314286 9.99619-16.822857 9.264762-26.819048-1.462857-18.285714-17.554286-32.426667-36.327619-32.426667H248.685714v70.704762z"
        fill="#FFFFFF"
      />
      <path
        d="M233.081905 815.055238h535.893333V850.895238H233.081905v-35.84z m0-89.234286h535.893333v35.84H233.081905v-35.84z m0-89.478095h535.893333v35.84H233.081905V636.342857z m0 0"
        fill="#9FA0A6"
      />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
